var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 25H3.13333C2.3866 25 2.01323 25 1.72801 24.8547C1.47713 24.7268 1.27316 24.5229 1.14532 24.272C1 23.9868 1 23.6135 1 22.8667V1M25 6.33333L17.7543 13.5791C17.4903 13.8431 17.3583 13.9751 17.206 14.0245C17.0721 14.0681 16.9279 14.0681 16.794 14.0245C16.6417 13.9751 16.5097 13.8431 16.2457 13.5791L13.7543 11.0876C13.4903 10.8236 13.3583 10.6916 13.206 10.6421C13.0721 10.5985 12.9279 10.5985 12.794 10.6421C12.6417 10.6916 12.5097 10.8236 12.2457 11.0876L6.33333 17M25 6.33333H19.6667M25 6.33333V11.6667",
    stroke: "#043F6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChart);
export default __webpack_public_path__ + "static/media/ic-chart.f707a8f09c6fd72363b3f1eeef8c50f2.svg";
export { ForwardRef as ReactComponent };